import styled, { css } from 'styled-components/macro';

export const MainTitle = styled.h3<{
  margin?: string;
  fontSize?: string;
  fontWeight?: number;
  lineHeight?: string;
  color?: string;
  fontFamily?: string;
  padding?: string;
  cursor?: string;
  width?: string;
  additionalStyle?: string;
}>`
  margin: ${({ margin }) => margin && margin};
  color: ${({ theme, color }) => (color ? color : theme.colors.black_100)};
  font-family: ${({ fontFamily, theme }) => (fontFamily ? fontFamily : theme.fontFamily.medium)};
  font-size: ${({ theme, fontSize }) => (fontSize ? `${fontSize}` : () => theme.fontSize.lg)};
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? `${fontWeight}` : () => theme.fontWeight.regular};
  line-height: ${({ theme, lineHeight }) =>
    lineHeight ? `${lineHeight}` : () => theme.lineHeight.one_2};
  ${({ padding }) => padding && `padding: ${padding}`};
  ${({ cursor }) => cursor && `cursor: ${cursor}`};
  ${({ width }) => width && `width: ${width}`};
  ${({ additionalStyle }) => additionalStyle && additionalStyle};

  font-style: normal;
`;

export const Paragraph = styled.p<{
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  letterSpacing?: string;
  margin?: string;
  color?: string;
  backgroundColor?: string;
  padding?: string;
  fontFamily?: string;
  border?: string;
  borderRadius?: string;
  justifyContent?: string;
  width?: string;
  height?: string;
  textAlign?: string;
  maxLines?: number;
  alignItems?: string;
  cursor?: string;
  display?: string;
  textDecoration?: string;
  wordBreak?: string;
  whiteSpace?: string;
}>`
  display: ${({ display }) => (display ? display : 'flex')};
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent}`};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};

  ${({ width }) => width && `width: ${width}`};
  ${({ height }) => height && `height: ${height}`};

  ${({ cursor }) => cursor && `cursor: ${cursor}`};

  ${({ maxLines }) =>
    maxLines &&
    css`
      overflow: hidden;
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
    `}

  align-items: ${({ alignItems }) => (alignItems ? alignItems : 'center')};
  font-family: ${({ fontFamily, theme }) => (fontFamily ? fontFamily : theme.fontFamily.medium)};
  font-size: ${({ theme, fontSize }) => (fontSize ? `${fontSize}` : () => theme.fontSize.lg)};
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? `${fontWeight}` : () => theme.fontWeight.regular};
  margin: ${({ theme, margin }) => (margin ? `${margin}` : () => theme.spacing.zero_2)};
  line-height: ${({ theme, lineHeight }) =>
    lineHeight ? `${lineHeight}` : () => theme.lineHeight.one_2};
  letter-spacing: ${({ theme, letterSpacing }) =>
    letterSpacing ? `${letterSpacing}` : () => theme.letterSpacing.sm};
  color: ${({ theme, color }) => (color ? color : theme.colors.black_100)};
  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor}`};
  ${({ padding }) => padding && `padding: ${padding}`};

  ${({ border }) => border && `border: ${border}`};
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius}`};
  ${({ textDecoration }) => textDecoration && `text-decoration: ${textDecoration}`};
  ${({ wordBreak }) => wordBreak && `word-break: ${wordBreak}`};
  ${({ whiteSpace }) => whiteSpace && `white-space: ${whiteSpace}`};

  font-style: normal;
`;

export const ParagraphDetail = styled.span<{ fontWeight?: string }>`
  display: inline-block;
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? `${fontWeight}` : () => theme.fontWeight.regular};
  margin-left: 0.25rem;
`;

export const LinkText = styled.a<{
  fontSize?: string;
  fontWeight?: string;
  margin?: string;
  color?: string;
  fontFamily?: string;
}>`
  font-size: ${({ theme, fontSize }) => (fontSize ? `${fontSize}` : () => theme.fontSize.lg)};
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? `${fontWeight}` : () => theme.fontWeight.regular};
  margin: ${({ theme, margin }) => (margin ? `${margin}` : () => theme.spacing.zero_2)};
  color: ${({ theme, color }) => (color ? color : theme.colors.black_100)};
  font-family: ${({ fontFamily, theme }) => (fontFamily ? fontFamily : theme.fontFamily.medium)};
`;
